import {
  Component,
  ISectionColumn,
  ISectionRow,
  isValidJson,
} from "@/views/formBuilder/components/dynamicValidation";
import { ref } from "vue";

export class FormBuilderService {
  private formStructure = ref<Array<ISectionRow>>([]);
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }
  private static instance: FormBuilderService | null;

  public initTable(data: any, sectionId: any) {
    try {
      this.formStructure.value = [];
      data?.formSectionRowModels?.forEach((rowElement) => {
        const row = {
          rowProp: {},
          columns: [] as ISectionColumn[],
          webId: rowElement.webId,
          key: rowElement?.key,
          formSectionId: rowElement?.formSectionId ?? sectionId.value,
          rowOrder: rowElement?.rowOrder ?? 1,
          rowSpan: rowElement?.rowSpan ?? 1,
        };
        if (rowElement.columns && !rowElement.deleted) {
          rowElement.columns.forEach((colElement) => {
            const col = {
              attrs: {},
              colSpan: +colElement.colSpan,
              components: [] as Component[],
              webId: colElement.webId,
              formSectionRowId: rowElement.webId,
              class: colElement?.cssClass ?? "",
              key: colElement?.key,
            };
            if (colElement.attrs && !colElement.deleted) {
              colElement.attrs.forEach((attr) => {
                if (!attr.deleted) {
                  col.attrs[attr.key] = attr.value;
                }
              });
            }
            if (colElement.components && !colElement.deleted) {
              colElement.components.forEach((comp) => {
                if (!comp.deleted) {
                  const component = {
                    attrs: {
                      label: comp.name,
                      defaultValue: comp?.text,
                    },
                    webId: comp.webId,
                    formSectionRowColumnId: colElement.webId,
                    component: comp.component,
                    name: comp.name,
                    key: comp?.key,
                    controlId: comp?.controlId,
                  };
                  if (comp.attrs && !comp.deleted) {
                    comp.attrs.forEach((attr) => {
                      if (isValidJson(attr.value)) {
                        component.attrs[attr.key] = JSON.parse(attr.value);
                      } else {
                        component.attrs[attr.key] = attr.value;
                      }
                    });
                  }
                  col.components.push(component);
                }
              });
            }
            row.columns.push(col);
          });
          this.formStructure.value.push(row);
        }
      });
      return this.formStructure.value;
    } catch (e) {
      console.log(e);
      return this.formStructure.value;
    }
  }
}
